module.exports = __webpack_public_path__ + "img/violin.9b6e69ff.jpg";